import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Environment } from 'src/environments/environment';

import {
  GetManureSpaceSettingsResponse,
  ManureSpaceSettings,
  ManureSpaceSettingToggles,
  ManureSpaceSettingTogglesRequestData,
  PostManureSpaceSettingsData,
} from '../models/manure-space-settings.models';

@Injectable({
  providedIn: 'root',
})
export class ManureSpaceSettingsService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.USE_LEGACY_MANURE_SPACE_ENDPOINT
    ? `${this.env.API_BASE_URL}/service/manure-space/secure/manurespace`
    : `${this.env.APIM_BASE_URL}/arable-service/manurespace`;
  protected baseUrlFieldAdvice = this.env.FIELD_ADVICE_REBUILD_DONE
    ? `${this.env.APIM_BASE_URL}/arable-service/advice`
    : this.env.API_BASE_URL + '/service/field-advice/secure';

  getSettings(manureSpaceId: number): Observable<ManureSpaceSettings[]> {
    return this.http
      .get<GetManureSpaceSettingsResponse>(`${this.baseUrl}/${manureSpaceId}/settings`)
      .pipe(map((d) => d.settings));
  }

  postSetting(
    manureSpaceSettingsData: PostManureSpaceSettingsData,
    manureSpaceId: number,
  ): Observable<{ id: number }> {
    return this.http.post<PostManureSpaceSettingsData>(
      `${this.baseUrl}/${manureSpaceId}/settings`,
      manureSpaceSettingsData,
    );
  }

  getSettingToggles(
    manureSpaceSettingTogglesRequestData: ManureSpaceSettingTogglesRequestData[],
  ): Observable<{ settingToggles: ManureSpaceSettingToggles[] }> {
    if (this.env.FIELD_ADVICE_REBUILD_DONE) {
      return this.http.post<{ settingToggles: ManureSpaceSettingToggles[] }>(
        `${this.baseUrlFieldAdvice}/fertilization-settings/nitrogenSettingToggles`,
        manureSpaceSettingTogglesRequestData,
      );
    }

    return this.http.post<{ settingToggles: ManureSpaceSettingToggles[] }>(
      `${this.baseUrlFieldAdvice}/fertilizationSetting/nitrogenSettingToggles`,
      manureSpaceSettingTogglesRequestData,
    );
  }
}
